import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Form, FormGroup, Input, Button, FormFeedback } from "reactstrap";
import Regex from "../../utilities/regex";
import { login } from "../../redux/actions";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { toast } from "react-toastify";

const Login = (props) => {


  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, toggleShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [remember, setRemember] = useState(false);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [disable, setdisable] = useState(false);
  const [color, setColor] = useState("#ffffff");
  const [validate, setValidate] = useState(false);
  const user = useSelector(state => state.userDetails.user)
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  const callback = () => {


    // if(user)
    // {
    //   props.socket.emit("new_notification", {
    //     name: 'User',
    //     email:'test@test.com',
    //     message: 'has login',

    // });
    // }

    setdisable(false);
    setIsSubmitting(false);
    setLoading(false);
    setValidate(false);
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    if (validate) {
      console.log("validating");
      const em = errors.email;
      const pw = errors.password;
      console.log("Errors, ", errors);
      if (!em && !pw) {
        setIsSubmitting(true);
        //   alert('Yes')
        dispatch(login({ values: { email, password }, remember, history: props.history, callback }));
      }
      else {
        callback();
        toast.error("Error!!! invalid values entered");
      }
    }
  }, [validate])

  // const onHandleChange = ({ target: { name, value } }) => {
  //   const obj = { email: false, password: false, };
  //   if (name === "email") {
  //     setErrors({ ...obj, [name]: false, });
  //     setEmail({ ...initialValues, [name]: value.replace(/\s/g, '') });
  //   } else {
  //     setErrors({ ...obj, [name]: false, });
  //     setInitialValues({ ...initialValues, [name]: value });
  //   }
  // };


  const handleSubmit = (e) => {
    e.preventDefault()
    let obj = { email: false, password: false, };
    setLoading(true);
    setdisable(true);
    if (!Regex.email(email)) {
      obj = { ...obj, email: true };
    }
    setErrors(obj);
    setValidate(true)
    // if (password.trim() === "" || password.length < 6) {
    //   setErrors({
    //     ...errors,
    //     password: true,
    //   });
    // }
  };


  const userDetails = useSelector((state) => state.userDetails.user);



  return (
    <div className="col-12 wrapper main-bggrey p-0">
      <div className="col-12 inner-page-content login-100 login-section login-page px-0 d-flex justify-content-center align-items-center">
        <div id="login" className="col-sm-12 my-4">
          <div className="login-container col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
            <div id="login-row" className="row justify-content-center align-items-center ">
              <div id="login-column" className="w-100">
                <h3 className="text-center page-head fw-bold  txtcolor">LiveStock Sign In</h3>
                <h5 className="text-center txt-lghtblue page-subhead mb-4 pb-2">Enter your account details below</h5>
                <div id="login-box" className="col-md-12">
                  {/* <form id="login-form" className="form site-form" action="" method="post">
                                        <div className="form-group  mb-4">
                                            <input type="text" name="username" id="username" className="form-control input-style min-input" placeholder="Email address/user name" />
                                        </div>
                                        <div className="form-group position-relative  mb-2">
                                            <input type="text" name="password" id="password" className="form-control input-style min-input" placeholder="Password" />
                                            <Link to={window.location.pathname} className="pwd-show">
                                                Show
                                            </Link>
                                        </div>
                                        <div className="form-group ">
                                            <div className="d-flex flex-wrap justify-content-end">
                                                <Link to="/forgotPassword" className="font-medium mb-4">Forgot Password?</Link>
                                            </div>

                                            <button type="submit" className="btn  text-white w-100 btn-custom min-input" >
                                                <span>
                                                    Sign in
                                                </span>
                                            </button>
                                        </div>
                                    </form> */}


                  <Form className="form site-form" onSubmit={handleSubmit}>
                    <FormGroup className="form-group  mb-4">
                      <Input
                        id="email"
                        className="form-control input-style min-input"
                        name="email"
                        placeholder="Email address/user name"
                        type="text"
                        required="true"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        invalid={email && !Regex.email(email)}
                      />
                      <FormFeedback id="email-err">
                        Please enter a valid email address.
                      </FormFeedback>{" "}
                    </FormGroup>
                    <div className="form-group position-relative mb-2">
                      <FormGroup>
                        <Input
                          id="password"
                          required="true"
                          type={showPassword ? "type" : "password"}
                          name="password"
                          onChange={(e) => setPassword(e.target.value)}
                          className="form-control input-style min-input"
                          placeholder="Enter password"
                          value={password}
                        />
                        <a
                          // href="/#"
                          className="pwd-show"
                          onClick={() => toggleShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? "Hide" : "Show"}
                        </a>
                      </FormGroup>
                    </div>
                    <FormGroup>
                      {" "}
                      <div className="d-flex flex-wrap justify-content-between mb-2">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="rememberMeCheck" onChange={(event) => {
                            if (event.target.checked)
                              setRemember(true);
                            else
                              setRemember(false);
                          }} checked={remember ? true : false} />
                          <label class="form-check-label" htmlFor="rememberMeCheck">
                            Remember me
                          </label>
                        </div>
                        <Link to="/forgot-password">
                          <a className="font-medium mb-4">Forgot Password?</a>
                        </Link>
                      </div>
                      <button
                        type="submit"
                        className="btn  text-white w-100 btn-custom min-input" disabled={disable}
                      >
                        {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                        {!loading && <span>Sign in</span>}
                      </button>
                    </FormGroup>
                  </Form>
                  <p className="w-100 text-center p-lght m-0">New to Livestock? <Link to="/sign-up">Sign up</Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;